import { render } from "./Vertical.vue?vue&type=template&id=f243aed8&scoped=true"
import script from "./Vertical.vue?vue&type=script&lang=js"
export * from "./Vertical.vue?vue&type=script&lang=js"

import "./Vertical.vue?vue&type=style&index=0&id=f243aed8&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f243aed8"]])

export default __exports__